import template from './travel-expense-details.html';
import controller from './travel-expense-details.controller';

let travelExpenseDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default travelExpenseDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/travel-expense-details/travel-expense-details.component.js